<template>
  <!-- 关于我们-基金会简介组件 -->
  <div id="about-intd">
    <div class="intd-box">
      <h3>{{pageData.news_title}}</h3>
      <div v-html="pageData.content"></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    chid: {
      type: String | Number,
      default: null
    }
  },
  data() {
    return {
      pageData: {}
    };
  },
  methods: {
    getData() {
      //获取列表信息
      this.$db
        .post(this.$db.config.getDataByChidUrl, { id: this.chid })
        .then(res => {
          this.pageData = res.data;
        });
    }
  },
  watch: {
    chid: function(val) {
      if (val) {
        this.getData();
      }
    }
  },

  created() {
    if (this.chid) {
      this.getData();
    }
  }
};
</script>

<style lang="scss" scoped>
#about-intd {
  width: 100%;
  margin: 80px 0;
}
.intd-box {
  width: 1300px;
  margin: 0 auto;
  > h3 {
    font-size: 30px;
    color: #333333;
    text-align: center;
    margin-bottom: 66px;
  }
  > p {
    font-size: 16px;
    line-height: 32px;
    color: #333333;
    margin-bottom: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Public/public_intd.vue